export default __webpack_public_path__ + "static/media/logo-unesco-ioc.2bad089b.svg";